import React, { useEffect, useRef, useState } from "react";
import "./Industries.css";

// Industry data with LOCAL icon paths
const industryData = [
  {
    title: "Industrial",
    icon: "/icons/industries/industrial.png",
    bg: "/industries/industrial.jpg",
  },
  {
    title: "Medical",
    icon: "/icons/industries/medical.png",
    bg: "/industries/medical.jpg",
  },
  {
    title: "Automotive",
    icon: "/icons/industries/automotive.png",
    bg: "/industries/automotive.jpg",
  },
  {
    title: "Locomotive",
    icon: "/icons/industries/locomotive.png",
    bg: "/industries/Locomotive.jpg",
  },
  {
    title: "Consumer",
    icon: "/icons/industries/consumer.png",
    bg: "/industries/consumer.jpg",
  },
  {
    title: "Energy",
    icon: "/icons/industries/energy.png",
    bg: "/industries/energy.jpg",
  },
  {
    title: "Process Engineering",
    icon: "/icons/industries/process-engineering.png",
    bg: "/industries/process.jpg",
  },
  {
    title: "Transportation",
    icon: "/icons/industries/transportation.png",
    bg: "/industries/transportation.jpg",
  },
];

const Industries = () => {
  const loopItems = [...industryData, ...industryData];

  const trackRef = useRef(null);
  const [isHovering, setIsHovering] = useState(false);
  const [isStopped, setIsStopped] = useState(false);

  const AUTO_SCROLL_SPEED = 0.6;

  useEffect(() => {
    let rafId;

    const tick = () => {
      const track = trackRef.current;
      if (track && !isHovering && !isStopped) {
        track.scrollLeft += AUTO_SCROLL_SPEED;
        const half = track.scrollWidth / 2;
        if (track.scrollLeft >= half) {
          track.scrollLeft -= half;
        }
      }
      rafId = requestAnimationFrame(tick);
    };

    rafId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafId);
  }, [isHovering, isStopped]);


  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    track.style.scrollSnapType = isHovering || isStopped ? "" : "none";
  }, [isHovering, isStopped]);

  const handleScroll = (direction) => {
    const track = trackRef.current;
    if (!track) return;
    setIsStopped(true);

    const half = track.scrollWidth / 2;
    const scrollAmount = track.clientWidth * 0.7;

    if (direction === "next" && track.scrollLeft >= half) {
      track.scrollLeft -= half;
    } else if (direction === "prev" && track.scrollLeft < scrollAmount) {
      track.scrollLeft += half;
    }

    track.scrollBy({
      left: direction === "next" ? scrollAmount : -scrollAmount,
      behavior: "smooth",
    });
  };

  const handleCardClick = () => {
    setIsStopped(true);
  };

  return (
    <section className="industries-section">
      <div className="ind-heading-wrap">
        <h2 className="ind-heading">
          Industries <span>We Serve</span>
        </h2>
        <div className="ind-heading-ornament">
          <div className="ind-orn-line-l" />
          <div className="ind-orn-gem" />
          <div className="ind-orn-line-r" />
        </div>
      </div>

      <div
        className="ind-carousel-wrapper"
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
      >
        <div className="industries-grid" ref={trackRef}>
          {loopItems.map((item, index) => (
            <div
              className="industry-card"
              key={`${item.title}-${index}`}
              onClick={handleCardClick}
            >
              <img
                src={item.bg}
                alt=""
                className="industry-bg-img"
                loading="lazy"
              />
              <div className="industry-inner">
                <div className="overlay"></div>
                <div className="industry-info">
                  <div className="industry-icon-wrapper">
                    <img
                      src={item.icon}
                      alt={item.title}
                      className="industry-icon"
                      loading="lazy"
                    />
                  </div>
                  <h3 className="industry-title">{item.title}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="ind-carousel-controls">
          <button
            className="ind-carousel-btn ind-carousel-prev"
            onClick={() => handleScroll("prev")}
            aria-label="Previous industries"
          >
            ‹
          </button>
          <button
            className="ind-carousel-btn ind-carousel-next"
            onClick={() => handleScroll("next")}
            aria-label="Next industries"
          >
            ›
          </button>
        </div>
      </div>
    </section>
  );
};

export default Industries;